import React, {Component} from 'react';
import {appendScript} from '../../shared/utility';
import {removeScript} from '../../shared/utility';
import styles from './geoWigetBar.module.css';

class GeoWigetBar extends Component {
    componentDidMount() {
        appendScript(
            'https://geowidget.easypack24.net/js/sdk-for-javascript.js',
        );
        window.easyPack.init({
            instance: 'pl',
            mapType: 'osm',
            searchType: 'osm',
            points: {
                types: ['parcel_locker'],
            },
            map: {
                useGeolocation: true,
                initialTypes: ['parcel_locker'],
            },
        });
        window.easyPack.dropdownWidget('easypack-widget', point => {
            this.setPoint(point);
        });
    }

    componentWillUnmount() {
        removeScript(
            'https://geowidget.easypack24.net/js/sdk-for-javascript.js',
        );
    }

    setPoint = point => {
        this.props.setInpostCode(point.name);
    };

    render() {
        return (
            <div className={styles.geoWigetBarWraper}>
                <div id="easypack-widget" />
                <p className={styles.geoWigetDescription}>
                    Aby wyszukać, wpisz pełną nazwę ulicy i/lub miasta.
                </p>
            </div>
        );
    }
}

export default GeoWigetBar;
